import AppRoot from '@/components/AppRoot';
import type { AppProps } from 'next/app';
import type { NextPage } from 'next';
import '@theme/global.css';

type PageWithLayoutFlag = NextPage & { noLayout?: boolean };

export default function App({ Component, pageProps }: AppProps) {
  const noLayout = (Component as PageWithLayoutFlag).noLayout;

  return (
    <AppRoot appContext={pageProps.appContext} noLayout={noLayout}>
      <Component {...pageProps} />
    </AppRoot>
  );
}
